__turbopack_context__.v({
  "entityFade": "LeftNavEntitySelector-module__5kEKSW__entityFade",
  "leftNavEntitySelector__currentEntity": "LeftNavEntitySelector-module__5kEKSW__leftNavEntitySelector__currentEntity",
  "newLeftNavEntitySelector__currentEntity": "LeftNavEntitySelector-module__5kEKSW__newLeftNavEntitySelector__currentEntity",
});
